import { getMeasurementDelayBucket, getMeasurementDelayBucketColor } from '../../../shared/services/measurementDelayBuckets.ts';
import { getWorkTimeInPeriod } from '../../../shared/services/shifts/workTimeInPeriod.ts';


interface Props {
    target: Date | null;
}

export function DelayStatusIndicator({
    target,
}: Props) {
    if (!target) return null;

    const delayDuringWorkHours = getWorkTimeInPeriod(target, new Date());
    const delayBucket = getMeasurementDelayBucket(delayDuringWorkHours);
    const backgroundColor = getMeasurementDelayBucketColor(delayBucket);

    return (
        <div
            className={`delay-status-indicator`}
            style={{ backgroundColor }}
        />
    );
}
